import { apiSlice } from "../../app/api/apiSlice"
import { logOut, setCredentials, setAuthChecked } from "./authSlice"
import { UserObject } from "../../shared/types"

type LoginArg = { email: string; password: string }
type LoginResponse = { status: string; token: string; data: { user: UserObject } }

type CheckLoginResponse = {
    status: string
    data: {
        loginStatus: boolean
        cookie: { jwt: string } | null
        userId?: string
    }
}

type LogoutResponse = { status: string; message: string }

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation<LoginResponse, LoginArg>({
            query: credentialsBody => ({
                url: 'api/v1/users/login',
                method: 'POST',
                body: { ...credentialsBody }
            })
        }),
        sendLogout: builder.mutation<LogoutResponse, string>({
            query: () => ({
                url: 'api/v1/users/logout',
                method: 'GET',
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(logOut(""))
                    setTimeout(() => {
                        dispatch(apiSlice.util.resetApiState())
                    }, 1000)
                } catch (err) {
                    console.log(err)
                }
            }
        }),
        checkLogin: builder.mutation<CheckLoginResponse, string>({
            query: () => ({
                url: 'api/v1/users/checkLogin',
                method: 'GET',
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    const jwt = data.data.cookie?.jwt
                    const userId = data.data.userId
                    const loginStatus = data.data.loginStatus
                    if (jwt && userId) {
                        dispatch(setCredentials({ jwt, userId, loginStatus }))
                    } else {
                        // No valid session — visitor is logged out. Still mark the
                        // check as done so auth-gated UI can resolve.
                        dispatch(setAuthChecked())
                    }
                } catch (err) {
                    dispatch(setAuthChecked())
                    console.error(`Error setting credentials in the checkLogin query: ${err}`)
                }
            }
        }),
    })
})

export const {
    useLoginMutation,
    useSendLogoutMutation,
    useCheckLoginMutation,
} = authApiSlice
